import React, { useEffect, useRef, useState } from "react";
import ArrowDownIcon from "../../../../assets/icons/ArrowDownIcon.jsx";
import { dropdownItems } from "../../../../constants/index.js";
import { DropdownWrapper, HeaderText, StyledMenu, StyledMenuItem } from "./elements.js";

const HistoryDropdown = ({ onSelect, selectedItem, translate }) => {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const dropdownRef = useRef(null);

	const handleMenuClick = (itemKey) => {
		onSelect(itemKey);
		setIsDropdownOpen(false);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsDropdownOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const menu = isDropdownOpen ? (
		<StyledMenu className="history-menu-wrapper">
			{dropdownItems
				.filter((item) => item.key !== selectedItem)
				.map((item) => (
					<StyledMenuItem
						key={item.key}
						onClick={() => handleMenuClick(item.key)}>
						{translate(item?.value)}
					</StyledMenuItem>
				))}
		</StyledMenu>
	) : null;

	return (
		<div ref={dropdownRef}>
			<DropdownWrapper
				isDropdownOpen={isDropdownOpen}
				rotate={isDropdownOpen}
				onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
				<HeaderText>
					{translate(dropdownItems.find((item) => item.key === selectedItem)?.value)}
				</HeaderText>
				<ArrowDownIcon />
			</DropdownWrapper>
			{menu}
		</div>
	);
};

export default HistoryDropdown;
